<template>
  <v-app-bar dense elevation="0" color="white" app v-if="shouldShow">
    <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
    <slot></slot>

    <v-toolbar-title class="font-weight-medium text-uppercase" v-if="tripName">{{
      tripName
    }}</v-toolbar-title>
    <v-toolbar-title v-else>{{ $t(`routes.${route}`) }} </v-toolbar-title>
    <v-spacer></v-spacer>
    <template v-if="user">
      <!-- <v-divider class="mx-3" inset vertical></v-divider> -->
      <NavbarProfile :user="user" />
    </template>
    <template v-else>
      <v-btn text v-if="currentRoute == 'SignUp'" :to="{ name: 'Login' }">{{
        $t("navbar.login")
      }}</v-btn>
      <v-btn text v-if="currentRoute == 'Login'" :to="{ name: 'SignUp' }">{{
        $t("navbar.signUp")
      }}</v-btn>
    </template>

    <!-- <template v-if="user" v-slot:extension>
      <v-tabs align-with-title background-color="transparent">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          v-for="(company,index) in companies"
          :to="{name:'Company', params:{ index:index ,companyId: company.id, }}"
          :key="company.id"
        >{{company.name }}</v-tab>
        <v-tab :to="{name:'Trips'}">Trips</v-tab>
        <v-tab
          :to="{name:'Trip',params: {tripId:currentTrip.id}}"
          v-if="currentTrip"
        >{{currentTrip.name}}</v-tab>
      </v-tabs>
    </template>-->
  </v-app-bar>
</template>

<script>
import NavbarProfile from "./NavBarProfile";

export default {
  name: "Navbar",
  components: { NavbarProfile },

  data() {
    return {
      tab: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.currentUser;
    },
    currentRoute() {
      return this.$route.name;
    },
    // currentTrip() {
    //   return this.$store.state.trip.trip;
    // },
    companies() {
      const arr = [];
      const { uid: userId } = this.$store.state.firUserz;
      const { companies } = this.$store.state;
      Object.values(companies).forEach((company) => {
        if (company.owner === userId || company.id === "OaaRuxV6tA3nobp42xMq") {
          arr.push(company);
        }
      });
      return arr;
    },

    shouldShow() {
      return !(this.$route.meta && (this.$route.meta.isAnonymus || this.$route.meta.isForLogin));
    },
    route() {
      return this.$route.name;
    },
    tripName() {
      if (this.$route.path.includes("/trip/")) {
        return this.$store.state.trip.trip
          ? this.$store.state.trip.trip.name
          : this.$t("routes.Home");
      }
      return null;
    },
  },
};
</script>
